// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules_dev/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lightbox__thumbnail{position:absolute;top:0;left:0;transition:.3s ease}.lightbox__thumbnail img{-o-object-fit:cover;object-fit:cover;width:100%;height:100%;border-radius:10px}.lightbox{z-index:2}.Body iframe{width:100%}", ""]);
// Exports
module.exports = exports;
